/**
 * Google AdSense slot configuration.
 *
 * Each slot is one of the ad units you create in the AdSense console
 * (Ads → By ad unit → Create new ad unit). Paste the `data-ad-slot` value
 * (a 10-digit numeric string) into the matching slot below.
 *
 * Until AdSense approves `hintononline.com` you can leave these as empty
 * strings — the <AdSlot /> component renders nothing when the slot ID is
 * blank, so the layout is unaffected.
 *
 * Publisher ID is set in /app/frontend/public/index.html.
 */
export const AD_SLOTS = {
  // Homepage banner — between the hero strip and the first editorial rail.
  // AdSense recommends a "horizontal" responsive unit here.
  homeTop: {
    slot: "",
    format: "horizontal",
    responsive: true,
  },
  // Homepage banner — above the watches rail / below newsletter.
  homeBottom: {
    slot: "",
    format: "horizontal",
    responsive: true,
  },
  // Inserted mid-body on article pages, between paragraphs.
  // "Fluid" (in-article) is purpose-built by AdSense for this placement.
  articleInBody: {
    slot: "",
    format: "fluid",
    layout: "in-article",
    responsive: true,
  },
  // Desktop-only skyscraper rail to the LEFT of the article column.
  // Hidden on mobile/tablet — use a "vertical" unit in AdSense.
  articleSideLeft: {
    slot: "",
    format: "vertical",
    responsive: true,
  },
  // Desktop-only skyscraper rail to the RIGHT of the article column.
  articleSideRight: {
    slot: "",
    format: "vertical",
    responsive: true,
  },
};
